export default __webpack_public_path__ + "static/media/ServiceSecurity.22d766bb.svg";